// Vendor Libraries
import React from 'react';

// Components
import PanelAction from '../core/panel-action';

// Contexts
import {SearchContext} from '../../contexts/search-context';

function ServicesRefreshPanelAction(props) {
    return (
        <SearchContext.Consumer>
            {({ refreshServicesData }) =>
                (
                    <PanelAction
                        {...{
                            hotkey: 'r',
                            icon: 'refresh',
                            title: 'Refresh Search Data',
                            weight: -20,
                            ...props,
                        }}
                        onClick={() => refreshServicesData()}
                    />
                )}
        </SearchContext.Consumer>
    );
}

export default ServicesRefreshPanelAction;
